module["exports"] = [
  "id",
  "title",
  "name",
  "email",
  "phone",
  "token",
  "group",
  "category",
  "password",
  "comment",
  "avatar",
  "status",
  "createdAt",
  "updatedAt"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/database/column.js
// module id = 2596
// module chunks = 1610